/* ============================================================
   TEMPOKICKSS — Theme JS  v2
   Single unified system. No inline JS conflicts.
   ============================================================ */

'use strict';

/* ── Helpers ─────────────────────────────────────────────── */
function $(id)  { return document.getElementById(id); }
function $$(sel){ return document.querySelectorAll(sel); }

function formatMoney(cents) {
  return new Intl.NumberFormat('en-GB', { style:'currency', currency:'GBP' }).format(cents / 100);
}

/* ── Cart Drawer ─────────────────────────────────────────── */
var CartDrawer = {
  drawer:    null,
  overlay:   null,
  body:      null,
  subtotal:  null,
  countEls:  null,

  init: function() {
    this.drawer   = $('cart-drawer');
    this.overlay  = $('cart-overlay');
    this.body     = $('cart-drawer-body');
    this.subtotal = $('cart-drawer-subtotal');
    this.countEls = $$('.cart-count');

    $$('[data-open-cart]').forEach(function(el) {
      el.addEventListener('click', function(e) { e.preventDefault(); CartDrawer.open(); });
    });
    $$('[data-close-cart]').forEach(function(el) {
      el.addEventListener('click', function() { CartDrawer.close(); });
    });
    if (this.overlay) {
      this.overlay.addEventListener('click', function() { CartDrawer.close(); });
    }
  },

  open: function() {
    if (!this.drawer) return;
    this.refresh();
    this.drawer.classList.add('is-open');
    if (this.overlay) this.overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  },

  close: function() {
    if (!this.drawer) return;
    this.drawer.classList.remove('is-open');
    if (this.overlay) this.overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  },

  refresh: function() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) { CartDrawer.render(cart); })
      .catch(function(e) { console.warn('Cart refresh error', e); });
  },

  render: function(cart) {
    /* Update counts */
    this.countEls.forEach(function(el) { el.textContent = cart.item_count; });
    var countDrawer = $('cart-drawer-count');
    if (countDrawer) countDrawer.textContent = cart.item_count;

    /* Update subtotal */
    if (this.subtotal) this.subtotal.textContent = formatMoney(cart.total_price);

    if (!this.body) return;

    if (cart.items.length === 0) {
      this.body.innerHTML = '<div class="cart-drawer__empty">Your bag is empty</div>';
      return;
    }

    this.body.innerHTML = cart.items.map(function(item) {
      var img = item.image
        ? '<img class="cart-item__image" src="' + item.image + '" alt="" loading="lazy">'
        : '<div class="cart-item__image" style="background:var(--color-bg-alt);"></div>';
      var variant = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<div class="cart-item__variant">' + item.variant_title + '</div>' : '';
      return (
        '<div class="cart-item" data-key="' + item.key + '">' +
          img +
          '<div class="cart-item__details">' +
            '<div class="cart-item__title">' + item.product_title + '</div>' +
            variant +
            '<div class="cart-item__price">' + formatMoney(item.final_line_price) + '</div>' +
            '<button class="cart-item__remove" data-key="' + item.key + '">Remove</button>' +
          '</div>' +
        '</div>'
      );
    }).join('');

    /* Bind remove buttons */
    this.body.querySelectorAll('.cart-item__remove').forEach(function(btn) {
      btn.addEventListener('click', function() { CartDrawer.removeItem(btn.dataset.key); });
    });
  },

  removeItem: function(key) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
    .then(function() { CartDrawer.refresh(); })
    .catch(function(e) { console.warn('Remove item error', e); });
  }
};

/* ── Add to Cart (AJAX) ──────────────────────────────────── */
var AddToCart = {
  init: function() {
    var form = document.getElementById('product-form');
    if (!form) return;
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      AddToCart.submit(form);
    });
  },

  submit: function(form) {
    var btn = form.querySelector('[type=submit]');
    var orig = btn ? btn.textContent : '';
    var variantId = form.querySelector('[name=id]') ? form.querySelector('[name=id]').value : '';

    if (!variantId) {
      if (btn) { btn.textContent = 'Please select a size'; }
      setTimeout(function() { if (btn) btn.textContent = orig; }, 2000);
      return;
    }

    if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function(r) {
      if (!r.ok) throw new Error('Add to cart failed');
      if (btn) btn.textContent = 'Added ✓';
      CartDrawer.refresh();
      setTimeout(function() { CartDrawer.open(); }, 300);
    })
    .catch(function() {
      if (btn) btn.textContent = 'Error — try again';
    })
    .finally(function() {
      setTimeout(function() {
        if (btn) { btn.textContent = orig; btn.disabled = false; }
      }, 2000);
    });
  }
};

/* ── Product Gallery ─────────────────────────────────────── */
var ProductGallery = {
  init: function() {
    $$('.product-gallery__thumb').forEach(function(thumb) {
      thumb.addEventListener('click', function() { ProductGallery.switchTo(thumb); });
    });
  },
  switchTo: function(thumb) {
    var gallery = thumb.closest('.product-gallery');
    if (!gallery) return;
    gallery.querySelectorAll('.product-gallery__thumb').forEach(function(t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
    var main = document.getElementById('main-image');
    if (main && thumb.dataset.src) main.src = thumb.dataset.src;
  }
};

/* ── Variant Selector ────────────────────────────────────── */
var VariantSelector = {
  variants: [],
  init: function() {
    var el = document.getElementById('product-variants-json');
    if (!el) return;
    try { this.variants = JSON.parse(el.textContent); } catch(e) { return; }

    $$('.size-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (btn.classList.contains('is-unavailable')) return;
        var grid = btn.closest('.size-grid');
        if (grid) grid.querySelectorAll('.size-btn').forEach(function(b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        VariantSelector.update();
      });
    });
  },
  update: function() {
    var selected = [];
    $$('.size-grid').forEach(function(grid) {
      var active = grid.querySelector('.size-btn.is-selected');
      selected.push(active ? active.dataset.value : null);
    });
    var match = this.variants.find(function(v) {
      return v.options.every(function(opt, i) { return !selected[i] || opt === selected[i]; });
    });
    var idInput = document.querySelector('[name=id]');
    var addBtn  = document.getElementById('add-to-cart');
    if (match && idInput) {
      idInput.value = match.id;
      if (addBtn) addBtn.textContent = match.available ? 'Add to Bag' : 'Sold Out';
    }
  }
};

/* ── FAQ Accordion ───────────────────────────────────────── */
var FAQ = {
  init: function() {
    $$('.faq-item__question').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var item = btn.closest('.faq-item');
        var isOpen = item.classList.contains('is-open');
        $$('.faq-item').forEach(function(i) {
          i.classList.remove('is-open');
          i.querySelector('.faq-item__question').setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }
};

/* ── Mobile Menu ─────────────────────────────────────────── */
var MobileMenu = {
  init: function() {
    var toggle = $('mobile-menu-toggle');
    var menu   = $('mobile-menu');
    var close  = $('mobile-menu-close');
    if (!toggle || !menu) return;
    toggle.addEventListener('click', function() {
      menu.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
    });
    if (close) close.addEventListener('click', function() {
      menu.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    });
  }
};

/* ── Search Overlay ──────────────────────────────────────── */
var SearchOverlay = {
  init: function() {
    var overlay = $('search-overlay');
    var closeBtn = $('search-close');
    var input   = overlay ? overlay.querySelector('.search-overlay__input') : null;
    if (!overlay) return;

    $$('[data-open-search]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        overlay.classList.add('is-open');
        if (input) input.focus();
      });
    });
    if (closeBtn) closeBtn.addEventListener('click', function() {
      overlay.classList.remove('is-open');
    });
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) overlay.classList.remove('is-open');
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') overlay.classList.remove('is-open');
    });
  }
};

/* ── Cart Page Quantity ──────────────────────────────────── */
var CartQuantity = {
  init: function() {
    $$('.qty-decrease, .qty-increase').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key  = btn.dataset.key;
        var span = btn.closest('.cart-line__qty') ? btn.closest('.cart-line__qty').querySelector('span') : null;
        if (!span) return;
        var delta  = btn.classList.contains('qty-increase') ? 1 : -1;
        var newQty = Math.max(0, parseInt(span.textContent, 10) + delta);
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: newQty })
        }).then(function() { window.location.reload(); });
      });
    });
  }
};

/* ── Announcement ticker pause on hover ──────────────────── */
var Ticker = {
  init: function() {
    var track = document.querySelector('.announcement-bar__track');
    if (!track) return;
    track.addEventListener('mouseenter', function() { track.style.animationPlayState = 'paused'; });
    track.addEventListener('mouseleave', function() { track.style.animationPlayState = 'running'; });
  }
};

/* ── Boot ────────────────────────────────────────────────── */
document.addEventListener('DOMContentLoaded', function() {
  CartDrawer.init();
  AddToCart.init();
  ProductGallery.init();
  VariantSelector.init();
  FAQ.init();
  MobileMenu.init();
  SearchOverlay.init();
  CartQuantity.init();
  Ticker.init();
});
